import React, { useEffect, useRef, useState } from 'react';

import { eTipoDownload } from '../../enum/eTipoDownload';
import Filter from '../../components/filter/filter';
import GestaoTable from './gestaoTable';
import { api } from '../../components/api/api';
import { FaGears } from 'react-icons/fa6';
import { Alert, Pergunta, AlertErro } from '../../util/Alertas';
import ProdutosSinteticos from '../../components/Modals/gestao/produtosSinteticos';
import Swal from 'sweetalert2';

function Gestao() {
    const produtosSinteticosRef = useRef();
    const [pedidos, setPedidos] = useState([]);
    const [pedidosFiltro, setPedidoFiltro] = useState([]);
    const [statusPagamento, setStatusPagamento] = useState([]);
    const [statusPedido, setStatusPedido] = useState([]);
    const [dtInicio, setDtInicio] = useState('');
    const [dtFim, setDtFim] = useState('');
    const [produtos, setProdutos] = useState([]);
    const [nome, setNome] = useState('');
    const [nPedido, setNPedido] = useState('');
    const [vendedores, setVendedores] = useState([]);
    const [vendedorSelecionado, setVendedorSelecionado] = useState(null);
    const [statusPagamentos, setStatusPagamentos] = useState([
        { status_pagamento_id: 1, nome: 'Parcial' },
        { status_pagamento_id: 2, nome: 'Pagamento Concluído' },
        { status_pagamento_id: 3, nome: 'Pagamento Pendente (inclui atrasados)' }
    ]);
    const [statusPagamentosSelecionado, setStatusPagamentosSelecionado] = useState(null);
    const [statusPedidoSelecionado, setStatusPedidoSelecionado] = useState("-3");
    const [linhasSelecionadas, setLinhasSelecionadas] = useState([]);
    const [carregando, setCarregando] = useState(true);

    const handleChangeLinhaSelecionada = (id, isList = false) => {
        if (isList) {
            setLinhasSelecionadas(linhasSelecionadas.length === id.length ? [] : id);
            return;
        }

        if (linhasSelecionadas.includes(id)) {
            setLinhasSelecionadas(linhasSelecionadas.filter(x => x !== id))
            return;
        }

        const copy = [...linhasSelecionadas];
        copy.push(id);
        setLinhasSelecionadas(copy);
    }

    const BuscarTodosPedidos = () => {
        setPedidos([]);
        setPedidoFiltro([]);
        setCarregando(true);
        api.get(`api/Pedidos/BuscarTodos?q=${nome}&dtInicio=${dtInicio}&dtFim=${dtFim}&nPedido=${nPedido.replaceAll("_", "")}&vendedor=${vendedorSelecionado}&stautsPagamento=${statusPagamentosSelecionado}&statusPedido=${statusPedidoSelecionado}`, res => {
            setCarregando(false);
            setStatusPagamento(res.data.statusPagamento);
            setStatusPedido(res.data.statusPedido);
            setPedidos(res.data.pedidos);

            if (statusPedidoSelecionado == "-1") {
                setPedidoFiltro(res.data.pedidos.filter(x => x.status_pedido_id !== 5 && x.status_pedido_id !== 4));
            }
            else if (statusPedidoSelecionado == "-3") {
                setPedidoFiltro(res.data.pedidos.filter(x => x.status_pedido_id !== 5));
            } else {
                setPedidoFiltro(res.data.pedidos);

            }

        }, erro => {
            setCarregando(false);
            AlertErro(erro);
        }, true)
    }

    const BuscarTodosVendedores = () => {
        api.get("/Usuario/Vendedores", res => {
            setVendedores(res.data);
        }, erro => {
            AlertErro(erro)
        })
    }

    const BuscarTodosProdutos = () => {
        api.get("/api/Produto/BuscarTodos", res => {
            setProdutos(res.data);
        }, erro => {
            AlertErro(erro)
        })
    }

    useEffect(() => { BuscarTodosPedidos(); BuscarTodosProdutos(); BuscarTodosVendedores(); }, []);

    const onChangeFiltroStatusPedido = e => {
        const value = e.target.value;
        setStatusPedidoSelecionado(parseInt(value));
        // if (value == "0" || value == 0) {
        //     setPedidoFiltro(pedidos);
        // } else if (value == "-1" || value == -1) {
        //     setPedidoFiltro(pedidos.filter(x => x.status_pedido_id !== 5 && x.status_pedido_id !== 4));
        // } else {
        //     setPedidoFiltro(pedidos.filter(x => x.status_pedido_id === parseInt(value)))
        // }
    }

    const handleOpenPedidosSinteticos = () => {
        produtosSinteticosRef.current.Open();
    }

    const refazerPedido = (pedidoId, ultimoPedido) => {
        function formatDateToInput(date) {
            return date.toISOString().split('T')[0];
        }

        function addDays(date, days) {
            const result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        }

        const novaData = new Date();
        novaData.setDate(new Date().getDate() + ultimoPedido.prazo_pagamento);

        Swal.fire({
            title: 'Informações de Pagamento',
            html: `
                  <label>Prazo para pagamento(Em Dias)</label>  
                  <input value='${ultimoPedido.prazo_pagamento}' id="prazoPagamentoDias" type="number" class="form-control" placeholder="Prazo para pagamento (em dias)">
                  <label>Prazo para pagamento(Vencimento)</label>
                  <input value='${formatDateToInput(novaData)}' id="PrazoPagamento" type="date" class="form-control" placeholder="Prazo para pagamento (vencimento)">
                  <label>Forma de pagamento</label>
                  <select value='${ultimoPedido.forma_pagamento}' class='form-control' name="FormaPagamento" id="FormaPagamento">
                      <option value="Pix">Pix</option>
                      <option value="Dinheiro">Dinheiro</option>
                      <option value="Cartão">Cartão</option>
                      <option value="Boleto">Boleto</option>
                  </select>
                  <label>Pedido emite nota fiscal?</label>
                  <select value='${ultimoPedido.emite_nota_fiscal}' class='form-control' name="PedidoEmiteNf" id="PedidoEmiteNf">
                      <option value="Não">Não</option>
                      <option value="Sim">Sim</option>
                  </select>
                  <label>Data Estimada Entrega</label>
                  <input id="DataEstimadaEntrega" type="date" class="form-control" placeholder="Data estimada de entrega">
                `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Salvar',
            didOpen: () => {
                const prazoDiasInput = document.getElementById('prazoPagamentoDias');
                const prazoDataInput = document.getElementById('PrazoPagamento');
                const entregaInput = document.getElementById('DataEstimadaEntrega');

                const today = new Date();
                const todayStr = formatDateToInput(today);

                // Set mínimo para datas
                prazoDataInput.min = todayStr;
                entregaInput.min = todayStr;

                // Set D+1 para entrega
                entregaInput.value = formatDateToInput(addDays(today, 1));

                // Se alterar os dias → calcula a data
                prazoDiasInput.addEventListener('input', () => {
                    const dias = parseInt(prazoDiasInput.value, 10);
                    if (!isNaN(dias)) {
                        const novaData = addDays(today, dias);
                        prazoDataInput.value = formatDateToInput(novaData);
                    }
                });

                // Se alterar a data → calcula os dias
                prazoDataInput.addEventListener('input', () => {
                    const dataSelecionada = new Date(prazoDataInput.value);
                    const diffMs = dataSelecionada - today;
                    const diffDias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
                    if (diffDias >= 0) {
                        prazoDiasInput.value = diffDias;
                    }
                });
            },
            preConfirm: () => {
                const prazoPagamentoDias = document.getElementById('prazoPagamentoDias').value;
                const PrazoPagamento = document.getElementById('PrazoPagamento').value;
                const FormaPagamento = document.getElementById('FormaPagamento').value;
                const PedidoEmiteNf = document.getElementById('PedidoEmiteNf').value;
                const DataEstimadaEntrega = document.getElementById('DataEstimadaEntrega').value;

                const hoje = new Date();
                const prazoPagamentoDate = new Date(PrazoPagamento);
                const entregaDate = new Date(DataEstimadaEntrega);

                // Validação obrigatoriedade
                if (!prazoPagamentoDias || !PrazoPagamento || !FormaPagamento || !PedidoEmiteNf || !DataEstimadaEntrega) {
                    Swal.showValidationMessage('Todos os campos são obrigatórios.');
                    return false;
                }

                // Validação de datas
                if (prazoPagamentoDate < hoje) {
                    Swal.showValidationMessage('A data de vencimento não pode ser anterior a hoje.');
                    return false;
                }
                if (entregaDate < hoje) {
                    Swal.showValidationMessage('A data estimada de entrega não pode ser anterior a hoje.');
                    return false;
                }

                return {
                    PrazoPagamentoDias: document.getElementById('prazoPagamentoDias').value,
                    PrazoPagamento: document.getElementById('PrazoPagamento').value,
                    FormaPagamento: document.getElementById('FormaPagamento').value,
                    PedidoEmiteNf: document.getElementById('PedidoEmiteNf').value,
                    DataEstimadaEntrega: document.getElementById('DataEstimadaEntrega').value,
                };
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const { PedidoEmiteNf, FormaPagamento, DataEstimadaEntrega, PrazoPagamentoDias } = result.value;

                const data = new FormData();
                const obj = JSON.stringify({
                    prazoPgt: PrazoPagamentoDias,
                    formaPgt: FormaPagamento,
                    pedidoEmiteNf: PedidoEmiteNf === 'Sim',
                    dataEstimadaEntrega: DataEstimadaEntrega
                });
                data.append("obj", obj);

                api.post("/api/Produto/Refazer/" + pedidoId, data, res => {
                    Alert("Pedido realizado com sucesso!", true)
                    BuscarTodosPedidos();
                }, err => {
                    AlertErro(err, 'Erro ao refazer o pedido')
                })
            }
        });
    }

    const onSubmitRefazerPedido = async (pedidoId) => {
        let ultimoPedido = {
            prazo_pagamento: 0,
            forma_pagamento: 'Pix',
            emite_nota_fiscal: "Não"
        };

        const pedido = pedidos.find(x => x.pedido_id == pedidoId);

        if ((await Pergunta('Deseja preencher os dados complementares de acordo com o ultimo pedido?'))) {
            api.get('/api/Pedido/UltimoPedido/' + pedido.cliente_id, async res => {
                ultimoPedido = {
                    prazo_pagamento: res.data.prazo_pagamento,
                    forma_pagamento: res.data.forma_pagamento,
                    emite_nota_fiscal: res.data.emite_nota_fiscal ? "Sim" : "Não"
                };
                refazerPedido(pedidoId, ultimoPedido);
            });
        } else {
            refazerPedido(pedidoId, ultimoPedido);
        }
    }

    return (
        <section className='app'>
            <ProdutosSinteticos
                ref={produtosSinteticosRef}
            />
            <div className="content">
                <Filter
                    fetchClientes={BuscarTodosPedidos}
                    setDataInicio={setDtInicio}
                    setDataFim={setDtFim}
                    dataInicio={dtInicio}
                    dataFim={dtFim}
                    showNovoCliente={false}
                    showFiltroNome={true}
                    filtroNome={nome}
                    filtroStatusPedido={true}
                    statusPedido={statusPedido}
                    onChangeFiltroStatusPedido={onChangeFiltroStatusPedido}
                    handleInputChange={e => { setNome(e.target.value); BuscarTodosPedidos() }}
                    extrairDados={true}
                    tipoDownload={eTipoDownload.GestaoPedidos}
                    nPedido={nPedido}
                    setNPedido={setNPedido}
                    showNPedido={true}
                    vededores={vendedores}
                    filtroVendedor={vendedores.length > 0}
                    setVendedorSelecionado={setVendedorSelecionado}
                    vendedorSelecionado={vendedorSelecionado}
                    statusPagamentos={statusPagamentos}
                    setStatusPagamentos={setStatusPagamentos}
                    statusPagamentosSelecionado={statusPagamentosSelecionado}
                    setStatusPagamentosSelecionado={setStatusPagamentosSelecionado}
                    filtroStatusPagamento={true}
                    onClickSintetico={handleOpenPedidosSinteticos}
                    sintetico={true}
                    statusPedidoSelecionado={statusPedidoSelecionado}
                />
                <GestaoTable
                    ReloadPage={BuscarTodosPedidos}
                    produtos={produtos}
                    pedidos={pedidosFiltro}
                    carregando={carregando}
                    statusPedido={statusPedido}
                    statusPagamento={statusPagamento}
                    handleChangeLinhaSelecionada={handleChangeLinhaSelecionada}
                    linhasSelecionadas={linhasSelecionadas}
                    setLinhasSelecionadas={setLinhasSelecionadas}
                    onSubmitRefazerPedido={onSubmitRefazerPedido}
                />
            </div>
        </section>
    );
}

export default Gestao;